import { render, staticRenderFns } from "./CompensatoryServiceDocuments.vue?vue&type=template&id=270ee926"
import script from "./CompensatoryServiceDocuments.vue?vue&type=script&lang=js"
export * from "./CompensatoryServiceDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports